import { render } from "./CommandWizardStep3.vue?vue&type=template&id=116b9372&ts=true"
import script from "./CommandWizardStep3.ts?vue&type=script&lang=ts"
export * from "./CommandWizardStep3.ts?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__